const UTM_KEY = 'river_utm_params';

const UTM_PARAM_NAMES = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

export interface UtmParams {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  first_landing_page: string;
  referrer?: string;
  captured_at: string;
}

/**
 * Capture the first landing page (and UTM params if present) on first visit.
 * First-touch-wins: never overwrites an existing capture.
 * Always fires — even without UTM params — so we record the entry point for
 * organic, direct, and referral traffic too.
 */
export function captureUtmParams(): void {
  try {
    if (localStorage.getItem(UTM_KEY)) return;

    const params = new URLSearchParams(window.location.search);

    const captured: UtmParams = {
      first_landing_page: window.location.pathname,
      captured_at: new Date().toISOString(),
    };

    for (const key of UTM_PARAM_NAMES) {
      const val = params.get(key);
      if (val) captured[key] = val;
    }

    const ref = document.referrer;
    if (ref) captured.referrer = ref;

    localStorage.setItem(UTM_KEY, JSON.stringify(captured));
    console.info(`[UTM] Captured: utm_source=${captured.utm_source ?? '(none)'} referrer=${captured.referrer ?? '(none)'} landing_page=${captured.first_landing_page}`);
  } catch {
    // localStorage unavailable (private browsing edge cases) — silently skip
  }
}

/**
 * Return the stored UTM params, or null if none were captured.
 */
export function getStoredUtmParams(): UtmParams | null {
  try {
    const stored = localStorage.getItem(UTM_KEY);
    return stored ? (JSON.parse(stored) as UtmParams) : null;
  } catch {
    return null;
  }
}

/**
 * Clear stored UTM params. Call after confirmed successful write to backend.
 */
export function clearUtmParams(): void {
  try {
    localStorage.removeItem(UTM_KEY);
  } catch {
    // ignore
  }
}
